// extracted by mini-css-extract-plugin
module.exports = {"Switcher":"ThemeSwitcher_Switcher__3ADMG","icon":"ThemeSwitcher_icon__2IpT9"};